import illo5x5 from '../../assets/images/psp/SizeGuide/updated/small-self-5x5-25x200.svg';
import illo5x10 from '../../assets/images/psp/SizeGuide/updated/small-self-5x10-50x400.svg';
import illo5x10mini from '../../assets/images/psp/SizeGuide/updated/mini-self-5x5.svg';
import illo5x15 from '../../assets/images/psp/SizeGuide/updated/medium-self-5x15-75x600.svg';
import illo10x10 from '../../assets/images/psp/SizeGuide/updated/medium-self-10x10-100x800.svg';
import illo10x15 from '../../assets/images/psp/SizeGuide/updated/medium-self-10x15-150x1200.svg';
import illo10x20 from '../../assets/images/psp/SizeGuide/updated/large-self-10x20-200x1600.svg';
import illo10x25 from '../../assets/images/psp/SizeGuide/updated/large-self-10x25-250x2000.svg';
import illo10x30 from '../../assets/images/psp/SizeGuide/updated/large-self-10x30-300x2400.svg';
import illo10x30extraLarge from '../../assets/images/psp/SizeGuide/updated/extra-large-10x30-300x2400.svg';
import UnitSizeFilter from '../../assets/images/psp/StepContent/unit-size-filter.svg';

import relatedContentImage3 from 'assets/images/psp/FeaturedContentImages/featured3.webp';
import relatedContentCheapest from 'assets/images/sgp/featuredContentImages/cheapest-storage-units-for-rent.webp';
import relatedContentDownsize from 'assets/images/sgp/featuredContentImages/mediumSizeRelatedContentImage4.webp';
import relatedContentPrices from 'assets/images/sgp/featuredContentImages/mediumSizeRelatedContentImage2.webp';

export const SizeGuideVideoContent = {
	title: 'Self Storage Unit Sizes Explained',
	description:
		"If you need to store it, there's a self storage unit for it. From cars and RVs to [moving boxes full of children's toys](https://www.selfstorage.com/blog/best-places-to-find-moving-boxes/), books, and sporting goods, self storage units come in a variety of sizes (and amenities) to securely store what matters most to you and your family.",
	videoName: 'Self Storage Unit Sizes Explained',
	videoSrc: '//www.youtube.com/embed/22NkjX5zWOY',
};

export const StorageUnitChartData = {
	lockers: {
		label: 'Lockers',
		title: 'Self Storage Lockers',
		description:
			'Self storage lockers are the smallest and cheapest self storage sizes available. Ranging from 2x2 to 4x5 with varying heights, these extra small self storage spaces are great for budget-conscious users who still need a little extra room for seasonal belongings, important documents, or off-season clothing.',
		units: [
			{
				id: 'loc1',
				size: '2x2',
				sqFt: '4 sq ft',
				cuFt: 'Ceiling height less than 8 ft',
				looksLike: 'Small gym locker',
				whatWillFit:
					'Documents, small electronics, or a few small boxes of personal belongings',
				illustration: illo5x5,
			},
			{
				id: 'loc2',
				size: '3x3',
				sqFt: '9 sq ft',
				cuFt: 'Ceiling height less than 8 ft',
				looksLike: 'Standard gym locker',
				whatWillFit:
					'A few boxes of clothing, documents, keepsakes, or sports equipment',
				illustration: illo5x10,
			},
			{
				id: 'loc3',
				size: '4x5',
				sqFt: '20 sq ft',
				cuFt: 'Ceiling height less than 8 ft',
				looksLike: 'A large cubby',
				whatWillFit:
					'Sports equipment, small appliances, and some seasonal decorations',
				illustration: illo5x10,
			},
		],
	},
	mini: {
		label: 'Mini Units',
		title: 'Mini Self Storage Units',
		description:
			'Mini self storage refers to units ranging from 5x5 to 5x10, with a ceiling height lower than 8ft. These extra small self storage units are great for individuals looking for a few extra square feet of storage space, or families who only need to store a little at a time.',
		units: [
			{
				id: 'm1',
				size: '5x5',
				sqFt: '25 sq ft',
				cuFt: 'Lower ceiling height',
				looksLike: 'Small walk-in closet or cabinet',
				whatWillFit:
					'Seasonal storage, clothing storage, keepsake storage',
				illustration: illo5x10mini,
			},
			{
				id: 'm2',
				size: '5x10',
				sqFt: '50 sq ft',
				cuFt: 'Lower ceiling height',
				looksLike:
					'Walk-in closet or half-bath with reduced ceiling height',
				whatWillFit:
					'Seasonal clothing, small appliances, moving boxes',
				illustration: illo5x10mini,
			},
		],
	},
	small: {
		label: 'Small Units',
		title: 'Small Self Storage Units',
		description:
			"Small self storage units include 5x5 and 5x10 spaces with a standard ceiling height of 8 feet. These units work best for individuals and small families looking to gain a large walk-in closet or small bedroom's worth of extra space.",
		units: [
			{
				id: 's1',
				size: '5x5',
				sqFt: '25 sq ft',
				// cuFt: '200 ft³',
				looksLike: 'A compact hallway closet',
				whatWillFit:
					'A dresser, a small mattress or nightstand set, and several small to medium-sized boxes.',
				illustration: illo5x5,
			},
			{
				id: 's2',
				size: '5x10',
				sqFt: '50 sq ft',
				// cuFt: '400 ft³',
				looksLike: 'A mid-sized walk-in closet',
				whatWillFit:
					'Up to a queen-sized bed set, nightstands, a television, and some boxes',
				illustration: illo5x10,
			},
		],
	},
	medium: {
		label: 'Medium Units',
		title: 'Medium Self Storage Units',
		description:
			'Medium self storage features some of the most popular self storage sizes: 5x15, 10x10, and 10x15. These units work great for growing families and those who need to store many, most, or all of their belongings.',
		units: [
			{
				id: 'm1',
				size: '5x15',
				sqFt: '75 sq ft',
				// cuFt: '200 ft³',
				looksLike: 'A large walk-in closet',
				whatWillFit:
					'Queen-sized bed set, a dresser, a nightstand, 1-2 small appliances, and some boxes',
				illustration: illo5x15,
			},
			{
				id: 'm2',
				size: '10x10',
				sqFt: '100 sq ft',
				// cuFt: '400 ft³',
				looksLike: 'A small to average bedroom',
				whatWillFit: 'The contents of a living room, plus a few boxes',
				illustration: illo10x10,
			},
			{
				id: 'm3',
				size: '10x15',
				sqFt: '150 sq ft',
				// cuFt: '400 ft³',
				looksLike: 'A large bedroom or small garage',
				whatWillFit:
					'The contents of a two-bedroom apartment, including a washer/dryer set, and some boxes',
				illustration: illo10x15,
			},
		],
	},
	large: {
		label: 'Large Units',
		title: 'Large Self Storage Units',
		description:
			'Large self storage includes versatile unit sizes such as the 10x20, 10x25, and 10x30. These units are ideal for oversized belongings and in some cases, even vehicles. Large units work best for those who need to store the contents of a large home.',
		units: [
			{
				id: 'l1',
				size: '10x20',
				sqFt: '200 sq ft',
				// cuFt: '200 ft³',
				looksLike: 'A standard one-car garage',
				whatWillFit:
					'Contents of a large home, including a couch, refrigerator, dining set, and some boxes',
				illustration: illo10x20,
			},
			{
				id: 'l2',
				size: '10x25',
				sqFt: '250 sq ft',
				// cuFt: '400 ft³',
				looksLike: 'A long single-car garage',
				whatWillFit:
					'Oversized items including a couch, mattress sets, washer/dryer, media center, and some boxes',
				illustration: illo10x25,
			},
			{
				id: 'l3',
				size: '10x30',
				sqFt: '300 sq ft',
				// cuFt: '400 ft³',
				looksLike: 'A two-car garage',
				whatWillFit:
					'Contents of a fully furnished 4-bedroom home, including couches, bedroom sets, large appliances, and several boxes',
				illustration: illo10x30,
			},
		],
	},
	xlarge: {
		label: 'Extra Large Units',
		title: 'Extra Large Self Storage Units',
		description:
			"Extra large self storage units are flex spaces that might resemble anything from an oversized garage to a small warehouse space. These come in handy when you've got more belongings than your home or life can reasonably accommodate. This could mean a car, a camper, small business inventory, or the entirety of your children’s dorm rooms…and then some",
		units: [
			{
				id: 'xl1',
				size: '10x30 & up',
				sqFt: '300+ sq ft',
				// cuFt: '200 ft³',
				looksLike: 'XL garage or compact warehouse space',
				whatWillFit:
					'Two standard sedans, or a large truck plus some tools and boxes. May also be used to store small business inventory or office supplies',
				illustration: illo10x30extraLarge,
			},
		],
	},
};

export const SizeChartData = {
	title: 'Self Storage Size Chart',
	showImage: false,
	hideActiveIndicator: true,
	SizeComparisonData: [
		{
			size: 'Locker',
			heading: 'Locker',
			desc: [
				'**Unit Sizes**\n\n 2×2, 3×3, 4×5',
				'**Who Can Use It**\n\n Apartment dwellers, students, or anyone with just a few items to stash',
				'**How to Use It** \n\n Documents, seasonal clothing, small boxes, and valuables',
			],
		},
		{
			size: 'Mini',
			heading: 'Mini',
			desc: [
				'**Unit Sizes**\n\n 5×5 (low ceiling), 5×10 (low ceiling)',
				"**Who Can Use It**\n\n Budget-conscious renters who don't need [vertical stacking space](https://www.selfstorage.com/blog/vertical-closet-storage-organization-space-saving-hacks/)",
				'**How to Use It** \n\n Boxes, small furniture, seasonal décor',
			],
		},
		{
			size: 'Small',
			heading: 'Small',
			desc: [
				'**Unit Sizes**\n\n 5×5, 5×10',
				'**Who Can Use It**\n\n Solo renters, students, or anyone clearing out one or two rooms on a tight budget',
				'**How to Use It** \n\n Mattress set, dresser, boxes, sports gear, closet overflow',
			],
		},
		{
			size: 'Medium',
			heading: 'Medium',
			desc: [
				'**Unit Sizes**\n\n 5×15, 10×10, 10×15',
				'**Who Can Use It**\n\n [Families in transition](https://www.selfstorage.com/blog/moving-with-kids/), downsizers, or anyone staging a home for sale',
				'**How to Use It** \n\n Two to three rooms of furniture, appliances, moving boxes',
			],
		},
		{
			size: 'Large',
			heading: 'Large',
			desc: [
				'**Unit Sizes**\n\n 10×20, 10×25, 10×30',
				"**Who Can Use It**\n\n Households on the move, renovators, or anyone storing a full home's worth of belongings",
				'**How to Use It** \n\n Three to four bedrooms, large appliances, small vehicles',
			],
		},
		{
			size: 'XL',
			heading: 'XL',
			desc: [
				'**Unit Sizes**\n\n 10×30 and up',
				'**Who Can Use It**\n\n Large families, business owners, or anyone with oversized storage needs',
				'**How to Use It** \n\n Full estate contents, commercial inventory, RVs, [boat self storage](https://www.selfstorage.com/storage-types/self-storage-for-boats)',
			],
		},
	],
};

export const StepContentData = {
	title: 'How to Choose the Right Self Storage Size',
	description:
		"Picking the right size comes down to a few simple things: what you're storing, how long it'll be there, and how often you'll need to get to it. Work through these questions and you'll have a clear answer before you know it.",
	steps: [
		{
			label: 'Step 1: Inventory Your Stuff',
			content:
				'Before making any self storage unit size decisions, take stock of everything you intend to store. \n\n We recommend sorting your belongings into a couple different categories:\n 1. Large or oddly shaped items that can’t fit into a box\n 2. Everything else or items that can fit into boxes or storage bins\n\n Large items like furniture, appliances, and mattresses are your anchor pieces. They take up the most space and should inform your sizing choices. Once you know how many large items you’re working with, it’s easier to figure out how to fit smaller, boxed items in your self storage unit',
		},
		{
			label: 'Step 2: Measure',
			content:
				'Grab a tape measure and start recording your measurements. This includes item height, width, and depth. This includes oddly shaped or awkward items in addition to the moving boxes or storage bins you’ll be using to store your items.',
		},
		{
			label: 'Step 3: How You’ll Use Storage',
			content:
				"Self storage can help you across any walk of life, from seasonal storage to major life transitions. It’s important to consider how you want to use storage to enhance your life.\n1. **How long are you storing?** [Short-term storage during a move looks different than a year-long rental while you renovate.](https://www.selfstorage.com/blog/long-term-vs-short-term-storage-guide/) Longer stays often mean more items added over time, so you’ll want to budget for extra wiggle room. \n2. **Will you need regular access?** If you're pulling things in and out on a regular basis, a packed unit will drive you crazy. Consider renting a large drive up self storage unit so you can move around inside and more easily access your belongings.\n3. **Are you stacking vertically?** Stacking boxes and smaller items on top of furniture can stretch a smaller unit further, just make sure boxes are sturdy and heavier items stay on the bottom.",
		},
		{
			label: 'Step 4: The Self Storage Size Guide',
			content:
				"Still not sure where to begin? Our size classifications are a practical starting point:\n1. **Lockers and Mini self storage units** work well for a handful of items or anyone watching their budget closely\n2. **Small self storage units** are a solid fit for one to two rooms of belongings\n3. **Medium self storage units** cover most two- to three-room households\n4. **Large and XL self storage units** are built for full homes, big moves, or business storage needs\n\n Keep in mind that dimensions vary by facility, so it's always worth confirming exact measurements before you book. You can find most unit dimension sizing information directly on our facility pages when you search and compare using SelfStorage.com.",
		},
	],
	tipCard: {
		icon: UnitSizeFilter,
		title: 'Expert Tip: When in Doubt, Size Up',
		description:
			"If you're on the fence between two sizes, go with the larger one. The price difference is usually smaller than you'd expect, and having a little extra room means your belongings stay organized and accessible instead of crammed and hard to reach.",
	},
};

export const ReviewData = {
	headerTitle: '',
	reviews: [
		{
			id: 'sgp-page-1',
			title: 'Customer service was excellent',
			stars: 5,
			text: 'Customer service was excellent. Knowledgeable about in line booking and description of unit sizes.',
			customerName: 'Mary R',
			date: 'January 21, 2026',
			link: 'https://www.trustpilot.com/reviews/696fc65edd7299c4a0fc4659',
		},
		{
			id: 'sgp-page-2',
			title: 'Fast,easy and money friendly …',
			stars: 5,
			text: 'Very easy to scroll through sizes and prices are exact; no surprise fees,fast and easy to reserve!',
			customerName: 'RiahM',
			date: 'October 16, 2025',
			link: 'https://www.trustpilot.com/reviews/68f08016086d8191573369df',
		},
		{
			id: 'sgp-page-3',
			title: 'Renting a storage unit online',
			stars: 5,
			text: 'The ability to rent a storage unit online is awesome. It is very easy to navigate and see the different sizes and their cost. I made my selection and I\'m guessing I got the "internet" price because it was a great price. I filled out all the necessary information, received a confirmation, and the first month is free. How can you not like this as an option, much better than finding the time to do it in person, in my opinion. Thanks !!!',
			customerName: 'William Hanner',
			date: 'September 17, 2025',
			link: 'https://www.trustpilot.com/reviews/68c9e3e9ab83b86de0ffcfaf',
		},
		{
			id: 'sgp-page-4',
			title: 'Incredibly Smooth Process and Friendly Service',
			stars: 5,
			text: 'The set up process was incredibly smooth. I even received a courtesy call from a representative to explain the unit sizes to ensure I picked the correct one and to welcome me.',
			customerName: 'Jennifer',
			date: 'August 13, 2025',
			link: 'https://www.trustpilot.com/reviews/689b77a39024d8d5c47ebd4d',
		},
	],
};

export const FAQSectionContent = {
	header: 'Frequently Asked Questions About Self Storage Sizes',
	description: '',
	faqs: [
		{
			question: 'What size self storage unit do I actually need?',
			answer: "The right size depends on what you're storing and how long you plan to store it. A small self storage unit (like a 5x5 or 5x10) works well for boxes, seasonal items, or a few pieces of furniture. If you're storing the contents of a full home or clearing out during a move, a large self storage unit (10x20 or bigger) gives you the breathing room to fit everything without the headache of playing Tetris. Our size guide walks you through what fits in each unit so you can choose with confidence.",
		},
		{
			question:
				'Is a small self storage unit enough for a one-bedroom apartment?',
			answer: 'In most cases, yes — a 5x10 or 10x10 self storage unit can comfortably hold the contents of a one-bedroom apartment, including furniture, boxes, and everyday essentials. That said, it helps to think through bulkier items like a couch, bed frame, or dresser before you book. When in doubt, sizing up a step is usually more budget-friendly than scrambling for a second unit later.',
		},
		{
			question:
				'When does it make sense to rent a large self storage unit?',
			answer: "A large self storage unit is worth considering any time you're dealing with a major life transition — a move, a home renovation, a growing family, or a downsizing project. If you're clearing out multiple rooms, storing large furniture, or need to access your items regularly, the extra space pays for itself in convenience. A 10x20 or 10x30 self storage unit can hold the equivalent of a 3-4 bedroom home with room to spare.",
		},
		{
			question:
				'Can I share a large self storage unit with someone else to save money?',
			answer: "It's more common than you'd think. Splitting a large self storage unit with a family member, roommate, or even a small business partner can be a practical, budget-friendly option — just make sure everyone's on the same page about access and organization upfront. Check with your self storage facility about their policies on shared access, as some require all users to be listed on the rental agreement.",
		},
		{
			question:
				"What's the difference between a small self storage unit and a locker?",
			answer: "A storage locker is typically the smallest option available — think of it as a large closet for documents, small boxes, or a handful of items. A small self storage unit, like a 5x5 or 5x10, gives you more floor space and vertical height, so you can actually stack and organize. If you're storing anything larger than boxes or bags, a small self storage unit will serve you much better than a locker.",
		},
	],
};

export const RelatedContent = {
	heading: 'Related Resources',
	type: 'unitCards',
	id: 'mini-storage-related-content',
	data: {
		slug: 'mini-storage-related-content',
		unitCards: [
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/self-storage-unit-size-guide-2/',
				layout: false,
				plain: true,
				date: '',
				image: relatedContentImage3,
				content:
					'Self Storage Size Guide: Finding the Perfect Storage Unit Size',
			},
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/cheapest-storage-unit-prices/',
				layout: false,
				plain: true,
				date: '',
				image: relatedContentCheapest,
				content: 'What is the Cheapest Storage Unit You Can Rent?',
			},
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/how-storage-reduces-cost-of-living/',
				layout: false,
				plain: true,
				date: '',
				image: relatedContentDownsize,
				content:
					'The Benefits of Downsizing Your Home: How to Reduce the Cost of Living with Self Storage',
			},
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/storage-unit-prices/',
				layout: false,
				plain: true,
				date: '',
				image: relatedContentPrices,
				content: 'Storage Unit Prices: How Much Is a Storage Unit?',
			},
		],
	},
};
